(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.PuntaMita",
                {
                    url: "/PuntaMita",
                    component: "puntamita",
                    PageTitle: "Punta Mita 2020",
                    requiredPermissions: "PuntaMita:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("puntamita",
        {
            templateUrl: "App/Resources/PuntaMita/puntamita.html",
            controller: puntamitaCtrl,
            bindings: {
                states: "<"
            }
        });

    puntamitaCtrl.$inject = ["amplitudeService"];

    function puntamitaCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
       
    }
})(window.app, window.angular); // jshint ignore:line